import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
import { getCometBrowserInfo, getSidecarThreadId, isCometBrowser, } from '#pplx/frontend/comet/client/utils.js';
const COMET_SIDECAR_THREADS_BY_ID_KEY = 'comet-sidecar-threads-by-id';
export const LS_COMET_FULLSCREEN_UPSELL_DISMISSED_KEY = 'hasDismissedFullscreenCometUpsell';
/**
 * ! Note - in incognito Comet you cannot use extensions or agents
 * If you need it - use isCometBrowser() check instead
 * This method can be used for UI gating like upsells or analytics
 * @deprecated - marked as deprecated so you need to think before using it
 */
export const isMaybeIncognitoComet = () => {
    return !!getCometBrowserInfo();
};
export const shouldTryOpenExistingTab = (e) => {
    if (e.defaultPrevented) {
        return false;
    }
    if (!isCometBrowser()) {
        return false;
    }
    // TODO: Consider using a more native interception for modifier keys
    // (e.g., handling at the component level or leveraging anchor tag attributes)
    // to avoid manual checks for ctrlKey/metaKey here
    if (e.ctrlKey || e.metaKey) {
        return false;
    }
    return true;
};
export const restoreSidecarThreadsFromCache = (store) => {
    const stateFromCache = SafeLocalStorage.getItem(COMET_SIDECAR_THREADS_BY_ID_KEY);
    if (stateFromCache) {
        const obj = JSON.parse(stateFromCache);
        for (const [sidecarThreadId, { url, updatedAt }] of Object.entries(obj)) {
            store
                .getState()
                .actions.setSidecarUrlById(sidecarThreadId, url, updatedAt);
        }
    }
};
export const saveSidecarThreadsToCache = (store) => {
    const updatedState = store.getState().sidecarUrlById;
    const obj = {};
    updatedState.forEach((value, key) => {
        if (key === '-1')
            return; // Skip placeholder tabId
        if (value.url === '/sidecar/' || value.url === '/sidecar')
            return; // Skip base URL
        obj[key] = { url: value.url, updatedAt: value.updatedAt };
    });
    SafeLocalStorage.setItem(COMET_SIDECAR_THREADS_BY_ID_KEY, JSON.stringify(obj));
};
export const tryNavigateToLastSidecarThreadForSourceTab = (store, router) => {
    const previousSidecarSourceTab = store.getState().sidecarSourceTab;
    const sidecarThreadId = getSidecarThreadId(previousSidecarSourceTab.tabId, previousSidecarSourceTab.secondaryTab?.tabId);
    const prevUrlForThisSidecarThreadFromCache = store
        .getState()
        .sidecarUrlById.get(sidecarThreadId)?.url;
    if (!prevUrlForThisSidecarThreadFromCache)
        return;
    const currentPathname = new URL(window.location.href).pathname;
    if (currentPathname === prevUrlForThisSidecarThreadFromCache) {
        return;
    }
    router.replace(prevUrlForThisSidecarThreadFromCache, 'Sidecar thread restored from cache');
};
//# sourceMappingURL=cometUtils.js.map